import ReactPaginate from "react-paginate";
import { useState } from "react";
import '../../assets/stylesheet/multiSelectInputType.css';


const TouchpTab = ({ tableData, touchpointView }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handlePageSizeChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const sortedData = [...tableData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchLower)
    );
  });
  const paginatedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <>
      <div className="row g-2 mb-2">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h4 className="page-sub-title">Touchpoints</h4>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-12 col-sm-6 col-md-6">
                <p className='mb-1 me-1 paginationTotalCount'>Total items: {filteredData.length}</p>
                  <div className="d-flex align-items-center">
                    <label htmlFor="page-size" className="item-per-page">
                      Items per page:
                    </label>
                    <select
                      className="form-control-sm did-floating-select h-30 w-50px px-2 me-3 mb-1"
                      id="page-size"
                      value={itemsPerPage}
                      onChange={handlePageSizeChange}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-6">
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="table-responsive custom-table custom-table-vertical-center">
                    <table className="table table-sm table-bordered mb-2">
                      <thead>
                        <tr>
                          <th
                            className="text-center"
                            onClick={() => handleSort(touchpointView==='touchpointView'?"TouchpointName":"GroupName")}
                          >
                            Name{" "}
                            {sortConfig.key === touchpointView==='groupView'?"GroupName":"TouchpointName"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("Requests")}
                          >
                            Requests{" "}
                            {sortConfig.key === "Requests"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("PeopleContacted")}
                          >
                            PeopleContacted{" "}
                            {sortConfig.key === "PeopleContacted"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("Responses")}
                          >
                            Responses{" "}
                            {sortConfig.key === "Responses"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("SmsSent")}
                          >
                            SmsSent{" "}
                            {sortConfig.key === "SmsSent"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("ResponseRate")}
                          >
                            ResponseRate{" "}
                            {sortConfig.key === "ResponseRate"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((item) => (
                          <tr key={item.ChildId}>
                            <td className="text-center">{touchpointView==='touchpointView'?item.TouchpointName:item.GroupName}</td>
                            <td className="text-center">{item.Requests}</td>
                            <td className="text-center">
                              {item.PeopleContacted}
                            </td>
                            <td className="text-center">{item.Responses}</td>
                            <td className="text-center">{item.SmsSent}</td>
                            <td className="text-center">{item.ResponseRate}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TouchpTab;
